function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 4.17594V2.95094C0 2.43316 0.419727 2.01343 0.9375 2.01343H17V0.938435C17 0.103786 18.0117 -0.313206 18.6004 0.275505L21.7254 2.95094C22.0915 3.31707 22.0915 3.91066 21.7254 4.27676L18.6004 6.85133C18.0139 7.43773 17 7.02656 17 6.18844V5.11344H0.9375C0.419727 5.11344 0 4.69371 0 4.17594Z",
  fill: "#666666"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22 11.9505L22 13.1755C22 13.6933 21.5803 14.113 21.0625 14.113L5 14.113L5 15.188C5 16.0227 3.98832 16.4397 3.39957 15.851L0.274569 13.1755C-0.0915257 12.8094 -0.0915257 12.2158 0.274569 11.8497L3.39957 9.27514C3.98609 8.68873 5 9.0999 5 9.93803L5 11.013L21.0625 11.013C21.5803 11.013 22 11.4328 22 11.9505Z",
  fill: "#666666"
});

var SvgIconAppSwitchDesktop = function SvgIconAppSwitchDesktop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAppSwitchDesktop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_app_switch_desktop.95c4177c.svg";
export { ForwardRef as ReactComponent };